import { MenuIdPeople } from '@jira/navigation-apps__constants/src/MenuIdPeople.tsx';
import {
	AsyncHorizontalOperationsNav,
	LazyHorizontalOperationsNav,
} from '@jira/navigation-apps__horizontal-nav-jsm-operations-container/src/async.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { LazyTeamDashboardSidebar } from '@jira/navigation-apps__sidebar-eoc-team-dashboard/src/async.tsx';
import { opsTeamLayout } from '@jira/platform__layouts-ops-team-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { eocPermissionsRoute } from '@jira/router-routes__eoc-permissions-routes/src/eocPermissionsRoute.tsx';
import { resources as teamDashboardResources } from '@atlassian/eoc-team-dashboard/resources';
import {
	resources as memberRolesResources,
	pageAccessResource,
} from '@atlassian/eoc-member-roles/resources';
import type { Route } from '@atlassian/react-resource-router';
import MemberRoles, { LazyMemberRoles } from './ui/spa/eoc/member-roles/index.tsx';

export const eocPermissionsRouteEntry: Route = createEntry(eocPermissionsRoute, () => ({
	group: 'eoc',
	// eslint-disable-next-line no-restricted-syntax
	component: MemberRoles,
	layout: opsTeamLayout,

	resources: [
		...getNavigationResources(),
		// pageAccessResource should be defined before memberRolesResources since they depend on it
		pageAccessResource,
		...memberRolesResources(),
		...teamDashboardResources(),
		getConsolidationStateResource(),
	],

	navigation: {
		menuId: MenuIdPeople,
		horizontal: AsyncHorizontalOperationsNav,
	},

	forPaint: [
		LazyHorizontalOperationsNav,
		LazyAtlassianNavigation,
		LazyMemberRoles,
		LazyTeamDashboardSidebar,
	],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
